import { render, staticRenderFns } from "./TipoEnderecoList.vue?vue&type=template&id=78051b94&scoped=true"
import script from "./TipoEnderecoList.vue?vue&type=script&lang=js"
export * from "./TipoEnderecoList.vue?vue&type=script&lang=js"
import style0 from "./TipoEnderecoList.vue?vue&type=style&index=0&id=78051b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78051b94",
  null
  
)

export default component.exports